import { Language } from 'types/language'

export const FullLanguages = {
  [Language.DUTCH]: 'Nederlands',
  [Language.FRENCH]: 'Français'
}

export const PardotFormHandlers = {
  BRUSSELS_BEER_PROJECT: '2020-12-23/3tsxf',
  NEWSLETTER: '2020-07-16/2b5pf',
  PRICING_SIMULATION: '2020-07-16/2b59c',
  REGISTRATION: '2020-07-30/2fvfw'
}

export enum SessionStorageKeys {
  MARKETING = 'MarketingStore'
}

export const socials = {
  instagram: 'https://www.instagram.com/boltenergie/',
  facebook: 'https://www.facebook.com/boltenergie/',
  email: 'mailto:info@boltenergie.be'
}

export const PORTAL_URLS = {
  instalment: 'https://my.boltenergie.be/billing/instalment',
  settlement: 'https://my.boltenergie.be/billing/settlement'
}
